// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"40031":"70348efff11d7584","42922":"ac28b4a7032ac117","72499":"7ebe4acd85434163"}[chunkId] + ".css";
};